







































import Vue, { PropType } from 'vue';
import * as InputValidation from '@/mixins/inputValidation';

import { BasePacket } from '@/models/packet';

export default Vue.extend({
  props: {
    packet: {
      type: Object as PropType<BasePacket>,
      required: true
    }
  },

  data() {
    return {
      isEditing: false,
      nameInput: this.packet.name,
      descriptionInput: this.packet.description
    };
  },

  computed: {
    saveDisabled(): boolean {
      return (
        (this.nameInput === this.packet.name &&
          this.descriptionInput === this.packet.description) ||
        !this.nameValidation.valid ||
        !this.descriptionValidation.valid
      );
    },

    nameValidation(): InputValidation.InputLengthValidation {
      return InputValidation.validateInput(this.nameInput, 250);
    },

    descriptionValidation(): InputValidation.InputLengthValidation {
      return InputValidation.validateInput(this.descriptionInput, 1250);
    }
  },

  methods: {
    save() {
      this.$emit('update', {
        ...this.packet,
        name: this.nameInput,
        description: this.descriptionInput
      });

      this.close();
    },

    close() {
      this.isEditing = false;
    }
  }
});
